import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import apiClient from '../apiClient/apiClient';
import { Product, ProductKey, UpdateProductRequest } from './product.types';

export const useGetProducts = (
    params?: {
      classNo?: number;
      status?: number;
    },
    enabled: boolean = true
) => {
  return useQuery<AxiosResponse<Product[]>>({
    queryKey: ['products', params?.classNo, params?.status],
    queryFn: () =>
        apiClient.get<Product[]>('/products', { params }),
    enabled
  });
};

export const useGetProduct = (
    {
        classId,
        productId
    }: ProductKey
) => {
  return useQuery({
    queryKey: ['getProduct', classId, productId],
    queryFn: () =>
        apiClient.get<Product>(`/classes/${classId}/products/${productId}`)
  });
};

export const useUpdateProduct = (
    {
        classId,
        productId
    }: ProductKey
) => {
  return useMutation({
    mutationKey: ['updateProduct', classId, productId],
    mutationFn: (request: UpdateProductRequest) =>
        apiClient.put<Product>(`/classes/${classId}/products/${productId}`, request)
  })
};

export const useDeleteProduct = (
    {
      classId,
      productId
    }: ProductKey
) => {
  return useMutation({
    mutationKey: ['deleteProduct', classId, productId],
    mutationFn: () =>
        apiClient.delete(`/classes/${classId}/products/${productId}`)
  })
}

export const useGetRecipeProducts = (
    requestBody: { classNo: string; baseNo: string; sizeNo: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Product[]>>({
    queryKey: ['getRecipeProducts', requestBody.classNo, requestBody.baseNo, requestBody.sizeNo],
    queryFn: () => apiClient.get<Product[]>('/recipes/products', { params: requestBody }),
    enabled
  });
};

export const useGetSubRecipeProducts = (
    requestBody: { classNo: string; baseNo?: string; sizeNo?: string },
    enabled: boolean = false
) => {
  return useQuery<AxiosResponse<Product[]>>({
    queryKey: ['getSubRecipeProducts', requestBody.classNo, requestBody.baseNo, requestBody.sizeNo],
    queryFn: () => apiClient.get<Product[]>('/sub-recipes/products', { params: requestBody }),
    enabled
  });
};